<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <b-form-group
          label="YouTube Video Bağlantısı"
          label-for="studioVideoUrl"
        >
          <b-input-group>
            <b-form-input
              id="studioVideoUrl"
              v-model="videoUrl"
              placeholder="https://www.youtube.com/watch?v=..."
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                :disabled="!videoUrl || submitStatus"
                @click="addVideo"
              >
                Ekle
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        v-for="item in filteredVideos"
        :key="item.id"
        cols="12"
        md="6"
        lg="6"
        class="mb-1"
      >
        <div class="border rounded p-1 h-100 d-flex flex-column">
          <b-embed
            v-if="item.video_embed"
            type="iframe"
            aspect="16by9"
            :src="youtubeUrl + item.video_embed"
          />
          <div
            v-else
            class="bg-light py-2 rounded text-center text-muted"
          >
            Video kodu bulunamadı
          </div>
          <div class="mt-1 d-flex justify-content-between align-items-center">
            <small class="text-muted">
              #{{ item.id }}
            </small>
            <small class="text-muted">
              studio: {{ item.id_studio || 1 }}
            </small>
          </div>
          <div class="text-right mt-1">
            <b-button
              variant="flat-danger"
              size="sm"
              :disabled="submitStatus"
              @click="removeVideo(item.id)"
            >
              <FeatherIcon icon="TrashIcon" class="mr-50" />
              Sil
            </b-button>
          </div>
        </div>
      </b-col>

      <b-col
        v-if="!filteredVideos.length"
        cols="12"
      >
        <div class="bg-light py-2 rounded text-center text-muted">
          Eklenmiş video bulunmuyor.
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BEmbed,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'StudioVideos',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BEmbed,
  },
  data() {
    return {
      videoUrl: null,
      youtubeUrl: 'https://www.youtube.com/embed/',
      submitStatus: false,
      studioId: 1,
    }
  },
  computed: {
    dataList() {
      const raw = this.$store.getters['studioVideos/dataList']
      if (Array.isArray(raw)) return raw
      if (raw && Array.isArray(raw.data)) return raw.data
      if (raw && typeof raw === 'object' && raw.id) return [raw]
      return []
    },
    filteredVideos() {
      return this.dataList.filter(item => Number(item.id_studio) === this.studioId)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('studioVideos/getDataList')
    },
    addVideo() {
      this.submitStatus = true
      this.$store.dispatch('studioVideos/getEmbedCode', this.videoUrl)
        .then(res => {
          if (res && res.id) {
            this.$store.dispatch('studioVideos/saveData', {
              video_embed: res.id,
              id_studio: this.studioId,
            }).then(() => {
              this.videoUrl = null
              this.getDataList()
              this.showToast({
                variant: 'success',
                title: 'İşlem Başarılı!',
                icon: 'CheckIcon',
                text: 'Video eklendi.',
              })
            })
          } else {
            this.showToast({
              variant: 'danger',
              title: 'İşlem Hatası!',
              icon: 'XIcon',
              text: 'Video bağlantısı çözümlenemedi.',
            })
          }
        })
        .finally(() => {
          this.submitStatus = false
        })
    },
    removeVideo(id) {
      this.submitStatus = true
      this.$store.dispatch('studioVideos/removeData', id)
        .then(() => {
          this.getDataList()
          this.showToast({
            variant: 'success',
            title: 'İşlem Başarılı!',
            icon: 'CheckIcon',
            text: 'Video silindi.',
          })
        })
        .finally(() => {
          this.submitStatus = false
        })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
